var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M14.14 10.593a6.666 6.666 0 11-8.807-8.706M14.667 7.667A6.667 6.667 0 008 1v6.667h6.667z","stroke":"currentColor","stroke-width":"1.333","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }